export default "__VITE_ASSET__CT4Udvny__"